import React from 'react';
import Typography from '@mui/material/Typography';
import styles from './css/LabelValueCD.scss';
import cn from 'classnames';
import { Box } from '@mui/material';

const LabelValueCD = ({
	Icon,
	label,
	value,
	iconColor = 'primary',
	valueColor,
	flash = false,
	fontSize = 'small',
	bold = false,
	color
}) => (
	<Box
		className={cn({ [styles.row]: true, [styles.flash]: flash })}
		sx={{ marginBottom: '4px' }}>
		<Box sx={{ display: 'flex', alignItems: 'center' }}>
			{Icon && <Icon fontSize={fontSize} color={iconColor} />}
			<Typography variant="normal" color={color}>
				{label}:
			</Typography>
		</Box>
		<span
			style={{
				color: valueColor || 'inherit',
				fontWeight: bold ? 'bold' : 'inherit'
			}}>
			{value}
		</span>
	</Box>
);

export default LabelValueCD;
